import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { LuArrowRight } from 'react-icons/lu'

/**
 * Catch-all 404. The SPA is served behind a `/* → app-shell 200` CDN rule, so we
 * can't return a true HTTP 404 status for arbitrary client routes — but we CAN
 * tell crawlers not to index these dead URLs (Google renders JS and honours a
 * client-set robots noindex), which stops them being treated as soft-404 index
 * bloat. Also gives users a real page with routes back in, instead of silently
 * bouncing to the homepage.
 */
const NotFoundPage = () => (
  <section className="region-page region-page--empty">
    <Helmet>
      <title>Page not found | Keyzee</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <p className="search-hero__eyebrow">404</p>
    <h1>We couldn’t find that page</h1>
    <p>The link may be broken or the page may have moved. Try one of these instead:</p>
    <ul className="region-index-list">
      <li><Link to="/listings"><span className="region-index-name">Browse listings</span></Link></li>
      <li><Link to="/sell-without-an-agent"><span className="region-index-name">Sell without an agent</span></Link></li>
      <li><Link to="/house-prices"><span className="region-index-name">UK house prices by area</span></Link></li>
      <li><Link to="/blog"><span className="region-index-name">Guides for home sellers</span></Link></li>
    </ul>
    <Link className="primary-button pill-action" to="/">
      Back to home <LuArrowRight aria-hidden="true" />
    </Link>
  </section>
)

export default NotFoundPage
